import {
  Flex,
  useColorModeValue,
  IconButton,
  HStack,
  Menu,
  MenuButton,
  Avatar,
  VStack,
  MenuList,
  MenuItem,
  MenuDivider,
  Box,
  FlexProps,
  Text,
  Skeleton,
  SkeletonCircle,
} from '@chakra-ui/react'
import { FiMenu, FiChevronDown, FiArrowLeft } from 'react-icons/fi'
import { ColorModeSwitcher } from '../../../ColorModeSwitcher'
import { useLocation, useNavigate } from 'react-router'
import { isSubpath, pathExists } from '../../../util/string'
import { Toolbar } from '../../Toolbar'
import { formatUserName, getUserTypeLabel } from '../../../util/user'
import { useSelector } from 'react-redux'
import { selectIsAdmin, selectUserDetails, selectUserLoading } from '../../../store/slices/User/selectors'
import { useAppDispatch } from '../../../store'
import { actions } from '../../../store/slices/User/reducer'
import { Link } from 'react-router-dom'

interface MobileProps extends FlexProps {
  onOpen: () => void
}

const MobileNav = ({ title, onOpen, ...rest }: MobileProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const userDetails = useSelector(selectUserDetails);
  const loading = useSelector(selectUserLoading);
  const isAdmin = useSelector(selectIsAdmin);

  const signoutHandler = () => {
    dispatch(actions.logout());
  };

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      gap={8}
      bg={useColorModeValue('gray.50', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between' }}
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />
      <HStack>
        {isSubpath(location.pathname) && pathExists(location.pathname) && (
          <IconButton
            colorScheme='gray'
            variant='ghost'
            aria-label=''
            isRound
            icon={<FiArrowLeft />}
            onClick={goBack}
          />
        )}
        <Text fontSize='2xl' fontWeight='light'>
          {title}
        </Text>
      </HStack>

      <HStack spacing={{ base: '0', md: '6' }}>
        {isAdmin && <Toolbar />}
        <ColorModeSwitcher />
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton py={2} transition="all 0.3s" _focus={{ boxShadow: 'none' }}>
              <HStack>
                {loading && (
                  <SkeletonCircle size="32px" />
                )}

                {!loading && (
                  <Avatar
                    size={'sm'}
                    name={formatUserName(userDetails)}
                    bg='brand.900'
                    color='white'
                  />
                )}
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2">
                  {loading && (
                    <>
                      <Skeleton height="12px" width="100px" mb={2} />
                      <Skeleton height="10px" width="80px" />
                    </>
                  )}
                  {!loading && (
                    <>
                      <Text fontSize="sm">{formatUserName(userDetails)}</Text>
                      <Text fontSize="xs" color="gray.600">
                        {getUserTypeLabel(userDetails?.role)}
                      </Text>
                    </>
                  )}
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('gray.200', 'gray.700')}>
              {
                isAdmin && (
                  <>
                    <MenuItem>
                      <Link to={`/colaboradores/${userDetails?.id}/editar`}>
                        Cuenta
                      </Link>
                    </MenuItem>
                    <MenuDivider />
                  </>
                )
              }
              <MenuItem>Ayuda</MenuItem>
              <MenuItem onClick={signoutHandler}>Cerrar sesión</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex >
  )
}

export default MobileNav;